import { get } from '../utils/makeRequest';

const ADMIN_API_LOGS_ENDPOINTS = {
  GET_API_LOGS: '/admin/api-logs',
};

export const adminApiLogsService = {
  /**
   * Get API logs with filters
   * @param {Object} filters - Filter parameters
   * @returns {Promise} - API logs data
   */
  getApiLogs: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    if (filters.status) params.append('status', filters.status);
    if (filters.method) params.append('method', filters.method);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);

    const queryString = params.toString();
    const endpoint = queryString 
      ? `${ADMIN_API_LOGS_ENDPOINTS.GET_API_LOGS}?${queryString}`
      : ADMIN_API_LOGS_ENDPOINTS.GET_API_LOGS;

    return get(endpoint);
  },
};
